import { CatchError } from "@core/error";
import { IReCaptcha } from "@modules/common/tool/recaptcha/recaptcha";
import { Environment } from "../../../../environments/Environment";
import { RegistObjectTreeService } from "./regist-object-tree.service";
import { AnonymousPageController } from "@modules/basic/page";
import { IAuthorizationUserRestV2Service } from "@modules/user/rest/authorization-user-rest-v2";
import { IAnonymousRestService } from "@modules/user/rest/anonymous-rest";
import { envConfig } from "@env/env-config";
import { RegExpUtils } from "@core/utils/reg-exp-utils";
import { IMessageDialog } from "@qpUIs/qp-message-dialog/qp-message-dialog.interface";
import { IError, IResponseEvent } from "@core/data-access/model";
import { IFormController } from "angular";
import { jumpParams } from "../social-login/social-login.controller";

export class RegistController extends AnonymousPageController implements angular.IController {

    public static readonly $inject: Array<string> = [
        "$objectTree", "authorizationUserRestService", "$scope",
        "$timeout", "eventBus", "qpLoading", "pageContext",
        "$injector", "anonymousRestService", "$q", "$uibModal", "$translate", "qpMessageDialog"
    ];

    public readonly rootPath: string;

    private userName: string;
    private userEmail: string;
    private userPass: string;
    private confirmPass: string;

    private formName: string;
    private isRegist: boolean;
    private passErrorMessage: string;
    private confirmPassErrorTip: string;
    private emailMessage: string;
    private recaptchaEmpty: boolean;
    private inputType: string;
    private confirmInputType: string;
    private diasplayPassword: boolean = false;
    private diasplayConfirmPass: boolean = false;

    private reCaptchaService: IReCaptcha;
    private toolTipShow: boolean;
    public privacy: boolean;
    private isUsedEmail: boolean = false;

    public registOptionShow: boolean = false;

    private homePage: string;

    // 本地缓存localSagePrivacyPolicy状态
    private cachePrivacyPolicy: boolean | undefined;

    private useSocialNetworkLogin: boolean;

    // 注册表单项-email提示信息
    private emailErrorTip: string;
    // 注册表单项-userName提示信息
    private userNameErrorTip: string;
    // 注册表单对象
    private registForm: IFormController;

    // 密码校验正则
    private PASSWORDPATT = RegExpUtils.REGEXP_USER_PASSWORD;
    private REGEXP_USER_EMAIL: RegExp = RegExpUtils.REGEXP_USER_EMAIL;
    private REGEXP_USER_NAME: RegExp = RegExpUtils.REGEXP_USER_NAME;
    // 页面重定向参数
    private redirectParam: string;
    constructor(
        public $objectTree: RegistObjectTreeService,
        private authorizationUserRestService: IAuthorizationUserRestV2Service,
        public $scope: qpmn.pages.regist.IRegistControllerScope,
        private $timeout: angular.ITimeoutService,
        private eventBus: qpmn.common.tool.IEventBus,
        private qpLoading: qp.loading.IQpLoading,
        public pageContext: qpmn.main.IPageContext,
        public $injector: angular.auto.IInjectorService,
        public anonymousRestService: IAnonymousRestService,
        public $q: angular.IQService,
        private $uibModal: angular.ui.bootstrap.IModalService,
        public $translate: angular.translate.ITranslateService,
        public qpMessageDialog: IMessageDialog
    ) {
        super($objectTree, anonymousRestService);

        this.rootPath = this.pageContext.rootPath;
        this.homePage = envConfig.getHomePage(this.rootPath);

        this.isRegist = false;
        this.formName = "registForm";
        this.toolTipShow = false;
        this.inputType = "password";
        this.confirmInputType = "password";
        // 用户隐私权限声明
        this.privacy = false;
        // 本地缓存--用户隐私权限
        this.cachePrivacyPolicy = false;

        this.useSocialNetworkLogin = false;
        this.$scope.$on("socialNetworkLogin", (event: angular.IAngularEvent, socialLoginParams: any[]) => {
            this.useSocialNetworkLogin = true;
            this.socialLogin(socialLoginParams);
        })
    }

    public $onInit() {
        if (location.search) {
            this.redirectParam = window.decodeURIComponent(window.location.search.split("?")[1]);
        }
        // 派发谷歌登录初始化参数
        if (!(/email/).test(this.redirectParam) && this.redirectParam) {
            const socialLoginParams: jumpParams = {
                prePath: this.redirectParam
            }
            this.$timeout(()=>{
                this.$scope.$emit("socialLoginOpen", socialLoginParams);
            })
        }
    }

    /**
     *  @description 判断当前页面是否符合登录成功跳转条件
     * */
    public pageJumpVerify() {
        let cs = this as unknown as qpmn.pages.regist.IRegistControllerScope;

        window.location.href = cs.registCtrl.getLoginUrl();
    }

    /**
     * @description 密码校验处理,当输入密码与确认密码的值更改后被调用
     * 1、密码格式校验（/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[`~!=|<>/@_#$%^&*\(\)\-\\\[\]\{\}\+\.\?\,\;\:\"\'])(?!.*\s).{8,20}$/）
     * 2、校验表单-email合法性
     * 3、校验表单-confirmPass合法性
     */
    private passValidate() {
        if (!this.registForm || !this.registForm.pass || !this.registForm.pass.$dirty) {
            return;
        } else {
            if (angular.isUndefined(this.userPass)) {
                // 设置表单项-pass项不合法
                this.registForm.pass.$setValidity('pattern', false);
                // 设置表单项-pass提示信息
                this.passErrorMessage = this.$translate.instant('REGIST_FORM_PASSWORD_ERROR_TIP1');
            } else {
                // 校验pass格式是否合法
                const isLegal = this.PASSWORDPATT.test(this.userPass);
                if (!isLegal) {
                    // 设置表单项-pass项不合法
                    this.registForm.pass.$setValidity('pattern', false);
                    // 设置表单项-pass提示信息
                    this.passErrorMessage = this.$translate.instant("REGIST_FORM_PASSWORD_ERROR_TIP1");
                    // TOOD 禁用注册按钮
                    // this.isRegist = false;
                } else {

                    if (this.userEmail === this.userPass) {
                        // 提示用户邮箱与用户密码不可相同
                        this.registForm.pass.$setValidity('pattern', false);
                        // 设置表单项-pass提示信息
                        this.passErrorMessage = this.$translate.instant('REGIST_FORM_PASSWORD_ERROR_TIP2');
                    } else if (this.userName === this.userPass) {
                        // 提示用户邮箱与用户名称不可相同
                        this.registForm.pass.$setValidity('pattern', false);
                        // 设置表单项-pass提示信息
                        this.passErrorMessage = this.$translate.instant('REGIST_FORM_PASSWORD_ERROR_TIP3');
                    } else {
                        // 设置表单项-pass项合法
                        this.registForm.pass.$setValidity('pattern', true);
                        // 设置表单项-pass提示信息
                        this.passErrorMessage = this.$translate.instant("");
                        // 表单项-confirmPass校验（用户密码与用户确认密码必须相同）
                        this.confirmPassValidate();
                    }
                }
            }
        }
    }

    /**
     * @description 确认密码校验处理,当输入确认密码的值被调用
     * 1、校验表单-confirmPass项 与 表单-Pass项是否一致
     */
    private confirmPassValidate() {
        if (!this.registForm || !this.registForm.confirmPass || !this.registForm.confirmPass.$dirty) {
            return;
        } else {
            if (angular.isUndefined(this.confirmPass)) {
                // 设置表单项-confirmPass不合法
                this.registForm.confirmPass.$setValidity('PassMatch', false);
                //密码不一致，给出错误提示
                this.confirmPassErrorTip = this.$translate.instant('REGIST_FORM_REPEAT_PASSWORD_TIP1');
            } else {
                // 获取表单项-confirmPass
                if (this.userPass != this.confirmPass) {
                    // 设置表单项-confirmPass不合法
                    this.registForm.confirmPass.$setValidity('PassMatch', false);
                    //密码不一致，给出错误提示
                    this.confirmPassErrorTip = this.$translate.instant('REGIST_FORM_REPEAT_PASSWORD_TIP1');
                    // 禁用注册按钮
                    // this.isRegist = false;
                } else {
                    // 设置表单项-confirmPass合法
                    this.registForm.confirmPass.$setValidity('PassMatch', true);
                    //  设置表单项-confirmPass提示信息为空
                    this.confirmPassErrorTip = '';
                }
            }
        }
    }


    /**
     * @description
     * 显示隐藏密码
     */
    private showPassword() {
        if (this.inputType === 'password') {
            this.diasplayPassword = !this.diasplayPassword;
            this.inputType = 'text';
        } else if (this.inputType === 'text') {
            this.diasplayPassword = !this.diasplayPassword;
            this.inputType = 'password';
        }
    }

    /**
     * @description
     * 显示隐藏确认密码
     */
    private showConfirmPass() {
        if (this.confirmInputType === 'password') {
            this.diasplayConfirmPass = !this.diasplayConfirmPass;
            this.confirmInputType = 'text';
        } else if (this.confirmInputType === 'text') {
            this.diasplayConfirmPass = !this.diasplayConfirmPass;
            this.confirmInputType = 'password';
        }
    }

    /**
     * @description
     * @returns
     */
    // @CatchError()
    public regist() {
        // 表单项-userName合法性校验
        this.userNameValidate();
        //表单项-emailName合法性校验
        this.emailValidate();
        // 表单项-pass合法性校验
        this.passValidate();
        // 表单项-confirmPass合法性校验
        this.confirmPassValidate();
        // 注册表单校验
        if (!this.registForm.$valid) {
            return;
        } else {
            this.isRegist = true;
        }
        // loading状态-开启
        this.qpLoading.open();
        // 获取谷歌验证
        let recaptchaName: string = window.isGrecaptcha
            ? "gReCaptchaService"
            : "otherReCaptchaService";
        this.reCaptchaService = this.$injector.get(recaptchaName);

        this.reCaptchaService.getReCaptcha({ action: "regist" }).then((reCaptchaToken) => {
            // 用户注册请求
            this.authorizationUserRestService.regist(
                this.userEmail,
                this.userPass,
                this.userName,
                reCaptchaToken
            ).then((registResp) => {
                if (registResp.success) {
                    let userInfo = registResp.data;

                    // 将剩余有效时间转为过期时间
                    // let expireDate = userInfo.expires_in + new Date().getTime();

                    // 设置缓存
                    // this.$objectTree.setLogin({
                    //     firstName: userInfo.firstName,
                    //     userName: userInfo.username,
                    //     token: userInfo.access_token,
                    //     tokenType: userInfo.token_type,
                    //     isAnonymous: false,
                    //     anonymousUserId: "",
                    //     expire: userInfo.expires_in,
                    //     partnerType: userInfo.partnerType,
                    // });
                    // 禁用注册按钮-关闭
                    this.isRegist = false;

                    // 注册成功处理
                    // 获取匿名用户id
                    let anonymousUserId = this.$objectTree.getAnonymousUserId() || 0;
                    //用户隐私权限本地存储
                    this.$objectTree.setCache('PrivacyPolicy', String(this.cachePrivacyPolicy));
                    // 弹框提示用户查看邮箱，验证注册邮箱-开启
                    this.eventBus.dispatch("partnerVerifyModalBoxOpen", {
                        userEmail: this.userEmail,
                        token: registResp.data
                    });
                    //  弹框提示用户查看邮箱，验证注册邮箱-关闭
                    this.eventBus.addEventListener("partnerVerifyModalBoxClose", this.pageJumpVerify, this.$scope);
                }
                // loading状态-关闭
                this.qpLoading.close();
            }, (error: IResponseEvent<IError>) => {
                // 注册失败处理
                let that = this;
                this.onRequestFailed(error).then(e => {
                    // 根据返回的errorCode匹配错误信息
                    // 当前邮箱已被注册过
                    if (e.code == "211187") {
                        that.$timeout(() => {
                            let title: qpLanguage.keys = "USER_REGIST_EMAIL_EXISTS_TITLE";
                            that.qpMessageDialog.info({
                                title: that.$translate.instant(title),
                                content: that.$translate.instant('USER_REGIST_EMAIL_EXISTS_CONTENT1'),
                                buttons: ['ok']
                            }).then(res => {
                                if (res == "ok") {
                                    that.$timeout(() => {
                                        document.getElementById('userEmail')!.focus();
                                    }, 500)
                                }
                            })
                        })
                    }
                    //当前邮箱与密码相同
                    else if (e.code == "211186") {
                        if (that.registForm && that.registForm.pass) {
                            // 提示用户邮箱与用户名称不可相同
                            this.registForm.pass.$setValidity('pattern', false);
                            // 设置表单项-pass提示信息
                            this.passErrorMessage = this.$translate.instant('REGIST_FORM_PASSWORD_ERROR_TIP2');
                            document.getElementById('userPass')!.focus();
                        } else {
                            that.$timeout(() => {
                                that.qpMessageDialog.info({
                                    title: that.$translate.instant('USER_SAME_EMAIL_PASSWORD_TITLE'),
                                    content: that.$translate.instant("USER_SAME_EMAIL_PASSWORD_CONTENT1"),
                                    buttons: ['ok']
                                }).then(res => {
                                    if (res == "ok") {
                                        that.$timeout(() => {
                                            document.getElementById('userPass')!.focus();
                                        }, 500)
                                    }
                                })
                            })
                        }
                    }
                    // 当前注册用户名与密码相同
                    else if (e.code == "211086") {
                        if (that.registForm && that.registForm.pass) {
                            // 提示用户邮箱与用户名称不可相同
                            this.registForm.pass.$setValidity('pattern', false);
                            // 设置表单项-pass提示信息
                            this.passErrorMessage = this.$translate.instant('REGIST_FORM_PASSWORD_ERROR_TIP3');
                            document.getElementById('userPass')!.focus();
                        } else {
                            that.$timeout(() => {
                                that.qpMessageDialog.info({
                                    title: that.$translate.instant('USER_SAME_EMAIL_PASSWORD_TITLE'),
                                    content: that.$translate.instant("USER_SAME_EMAIL_PASSWORD_CONTENT2"),
                                    buttons: ['ok']
                                }).then(res => {
                                    if (res == "ok") {
                                        that.$timeout(() => {
                                            document.getElementById('userPass')!.focus();
                                        }, 500)
                                    }
                                })
                            })
                        }
                    }
                    // 谷歌人机验证失败
                    else if (e.code == "2000090" || e.code == "2000068") {
                        let key: qpLanguage.keys = "A1102B2000090";
                        that.qpMessageDialog.info({
                            title: that.$translate.instant("USER_GOOGLE_RECAPTCHA_VERIFICATION_FAILED_TITLE"),
                            content: that.$translate.instant(key, { supportmail: that.supportmail }),
                            contentType: "HTML"
                        })
                    }
                    // // google请求参数解析失败
                    // else if (e.code == "2000067") {

                    // }
                    // // 访问谷歌服务器失败
                    // else if (e.code == "2000080") {

                    // }
                    // // email有相同的patner
                    // else if (e.code == "211188") {

                    // }
                    else {
                        that.openUnhandleErrorMsgDialog();
                        that.sendError("partner.registController.regist()", error);
                    }
                })

                // this.confirmMessage = Environment.codeMessage[error.data.data.code];
                // 禁用注册按钮
                this.isRegist = false;

                this.qpLoading.close();
            })
        }, (failResp) => {
            // 获取谷歌验证码错误处理
            let key: qpLanguage.keys = "A1102N001";

            // 未获取到google recaptcha服务
            this.qpMessageDialog.warning({
                title: this.$translate.instant("CONNECTION_RECAPTCHA_FAIL_TITLE"),
                content: this.$translate.instant(key),
                contentType: "HTML"
            })

            this.qpLoading.close();
        });
    }

    /**
     * @description
     * 邮箱与其他登录方式切换
     */
    public jumpEmail() {
        this.registOptionShow = !this.registOptionShow;
    }

    public socialLogin(socialLoginParams) {
        // console.log(socialLoginParams);
    }


    /**
     * @decription 用户邮箱校验
     * 
     * 1、符合邮箱规则（/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/）
     * 2、用户邮箱与用户密码不相同
     * 
    */
    private emailValidate() {

        if (!this.registForm || !this.registForm.emailName || !this.registForm.emailName.$dirty) {
            return;
        } else {
            // 获取表单项-emailName
            let emailItem = this.registForm.emailName;
            if (angular.isUndefined(this.userEmail)) {
                // 邮箱格式非法
                this.registForm.emailName.$setValidity('InvalidEmail', false);
                // 设置表单项-emailName提示信息
                this.emailErrorTip = this.$translate.instant('REGIST_FORM_EMAIL_ERROR_TIP1');
            } else {
                // 校验表单项-emailName格式是否合法
                let isLegal = this.REGEXP_USER_EMAIL.test(this.userEmail);
                // 校验表单项-emailName与用户密码是否相同
                if (!isLegal) {
                    // 邮箱格式非法
                    this.registForm.emailName.$setValidity('InvalidEmail', false);
                    // 设置表单项-emailName提示信息
                    this.emailErrorTip = this.$translate.instant('REGIST_FORM_EMAIL_ERROR_TIP1');
                } else {
                    this.registForm.emailName.$setValidity('InvalidEmail', true);
                    // 设置表单项-emailName提示信息为空
                    this.emailErrorTip = '';
                    // 表单项-pass项合法项校验
                    this.passValidate();
                }
            }
        }
    }
    /**
     * @description 注册表单-用户名合法性校验
     * 1、长度1-36(数字|大写字母|小写字母|特殊字符)
     * 2、用户名不能与用户密码相同
     * */
    private userNameValidate() {
        if (!this.registForm || !this.registForm.userItemName || !this.registForm.userItemName.$dirty) {
            return;
        } else {
            // 获取表单项-userName
            let userNameItem = this.registForm.userItemName;
            if (angular.isUndefined(this.userName)) {
                this.registForm.userItemName.$setValidity('InvalidName', false);
                // 设置表单项-emailName提示信息为空
                this.userNameErrorTip = this.$translate.instant('REGIST_FORM_NICKNAME_ERROR_TIP1');
            } else {
                // 校验表单项-emailName格式是否合法
                let isLegal = this.REGEXP_USER_NAME.test(this.userName);
                if (!isLegal) {
                    this.registForm.userItemName.$setValidity('InvalidName', false);
                    // 设置表单项-emailName提示信息为空
                    this.userNameErrorTip = this.$translate.instant('REGIST_FORM_NICKNAME_ERROR_TIP1');
                } else {

                    this.registForm.userItemName.$setValidity('InvalidName', true);
                    // 设置表单项-emailName提示信息为空
                    this.userNameErrorTip = '';
                    // 表单项-pass项合法项校验
                    this.passValidate();
                }
            }
        }
    }

    /**
     * @description 获取login登录页地址
     * */
    private getLoginUrl(): string {
        let href: string;
        if (this.redirectParam) {
            href = this.pageContext.rootPath + "partner/login/" + "?" + encodeURIComponent(this.redirectParam);
        } else {
            href = this.pageContext.rootPath + "partner/login/";
        }
        return href;
    }


    /**
     * @description 获取regist注册页面地址
     * */
    private getRegistUrl(): string {
        let href: string;
        if (this.redirectParam) {
            href = this.pageContext.rootPath + "partner/regist/" + "?" + encodeURIComponent(this.redirectParam);
        } else {
            href = this.pageContext.rootPath + "partner/regist/";
        }
        return href;
    }

}
